import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, DependentTableNames } from './constants';

class VerificationHistoryProvider extends BaseApi {
	schemaUrl(tableName: DependentTableNames) {
		return `/${this.area}/${NAME}/${tableName}Schema`;
	}

	tableUrl(tableName: DependentTableNames) {
		return `/${this.area}/${NAME}/${tableName}Rows`;
	}
}
export const apiProvider = new VerificationHistoryProvider(DMS_MODULE, NAME);
